// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportEnrollRenterInCreditTrackingHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking } from '@zg-rentals/ts-rent-payment-client';

import type { RentCreditReportEnrollCreditTrackingWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Args {
  postData: RentCreditReportEnrollCreditTrackingWebApiRequestDto;
}

export type RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Options =
  UseMutationOptions<
    void,
    unknown,
    RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Args
  >;

/**
 * Enroll renter in credit tracking
 */
export const useRentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking = ({
  httpClient,
  ...options
}: Omit<RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking_Args) =>
      RentCreditReportEnrollRenterInCreditTrackingHandler_enrollRenterInCreditTracking(args.postData, httpClient),
  });
};
